import React from 'react';
import { Card, palettes, LegalBody } from '@indigo-ag/component-module';
import { faFileAlt, faTimes, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { createStylesHook } from 'shared/hooks/createStylesHook';

const useStyles = createStylesHook(({ typography: { pxToRem } }) => ({
  documentCard: {
    padding: '11px',
    marginBottom: '12px',
    position: 'relative'
  },
  documentNameWrapper: {
    maxWidth: '94%'
  },
  documentName: {
    fontSize: pxToRem(13),
    color: palettes.brand.gray['700'],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: 5
  },
  documentIconBackground: {
    backgroundColor: palettes.legacy.blue.D25,
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    marginRight: '11px'
  },
  documentIcon: {
    color: palettes.neutral.white,
    margin: '2px 5px',
    fontSize: pxToRem(12.8)
  },
  actionIcon: {
    color: palettes.brand.blue.base,
    fontSize: pxToRem(16),
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.1)',
      transition: '.2s',
      color: palettes.brand.gray['700']
    }
  },
  successIcon: {
    color: palettes.coastal.accent.green,
    fontSize: pxToRem(16)
  },
  progressBar: {
    position: 'absolute',
    height: 4,
    borderRadius: 6,
    backgroundColor: palettes.brand.blue.base,
    left: 3,
    bottom: 2,
    transition: 'width 0.5s ease',
    '&.completed': {
      backgroundColor: palettes.coastal.accent.green
    }
  }
}));

export interface UploadDocumentCardProps {
  documentName: string;
  onRemove: () => void;
  progress?: number;
}

export const UploadDocumentCard: React.FunctionComponent<UploadDocumentCardProps> = ({
  documentName,
  onRemove,
  progress
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <Card className={classes.documentCard}>
      <div className="flex flex-space-btw align-items-center">
        <div className={`flex align-items-center ${classes.documentNameWrapper}`}>
          <div className={classes.documentIconBackground}>
            <FontAwesomeIcon icon={faFileAlt} className={classes.documentIcon} />
          </div>
          <span className={classes.documentName}>{documentName}</span>
        </div>
        {progress && progress > 0 && progress < 100 ? (
          <LegalBody>{progress}%</LegalBody>
        ) : progress === 100 ? (
          <FontAwesomeIcon icon={faCheck} className={classes.successIcon} />
        ) : (
          <FontAwesomeIcon icon={faTimes} className={classes.actionIcon} onClick={onRemove} />
        )}
      </div>
      <div
        className={`${classes.progressBar} ${progress === 100 ? 'completed' : ''}`}
        style={{ width: `calc(${progress}% - 6px)` }}
      ></div>
    </Card>
  );
};
